<div>

	<div class="mb-3 row">
		<label class="col-lg-4">Color:</label>
		<p-colorPicker class="col-lg-8" [(ngModel)]="lineColor" (onChange)="onLineColorChange($event)"></p-colorPicker>
	</div>

	<div class="mb-3 row">
		<label class="col-lg-4">Weight:</label>
		<p-dropdown class="col-lg-8" [options]="lineWidthOptions" [(ngModel)]="lineWidth" [style]="{'width':'175px'}"
					[showClear]="false" (onChange)="onLineWidthChange($event)">
			<ng-template let-item pTemplate="selectedItem">
				<pen-pattern-viewer lineWidth="{{item.value}}"></pen-pattern-viewer>
			</ng-template>
			<ng-template let-option pTemplate="item">
				<div>
					<pen-pattern-viewer [lineWidth]="option.value"></pen-pattern-viewer>
				</div>
			</ng-template>
		</p-dropdown>
	</div>

	<div class="mb-3 row">
		<label class="col-lg-4">Dash Type:</label>
		<p-dropdown class="col-lg-8" [options]="lineDashStyleOptions" [(ngModel)]="lineDashStyle" [style]="{'width':'175px'}"
					[showClear]="false" (onChange)="onLineDashStyleChange($event)">
			<ng-template let-item pTemplate="selectedItem">
				<pen-pattern-viewer lineDashStyle="{{item.value}}"></pen-pattern-viewer>
			</ng-template>
			<ng-template let-option pTemplate="item">
				<div>
					<pen-pattern-viewer [lineDashStyle]="option.value"></pen-pattern-viewer>
				</div>
			</ng-template>
		</p-dropdown>
	</div>

</div>
